import { useState } from 'react';

import { Cell } from './Cell';
import { Controls } from './Controls';

type Props = {
  year: number;
  onSelectYear: (_year: number) => void;
};

export const YearView = ({ year, onSelectYear }: Props) => {
  const [maxYear, setMaxYear] = useState(year + (10 - (year % 10)));

  const handlePrevious = () => {
    setMaxYear(p => p - 10);
  };

  const handleNext = () => {
    setMaxYear(p => p + 10);
  };

  return (
    <div>
      <Controls onPrevious={handlePrevious} onNext={handleNext} label={`${maxYear - 11} - ${maxYear}`} />
      <div className="w-64 grid grid-cols-4">
        {Array.from({ length: 12 })
          .map((_, index) => (
            <Cell
              key={maxYear - index}
              isSelected={year === maxYear - index}
              onClick={() => onSelectYear(maxYear - index)}
            >
              {maxYear - index}
            </Cell>
          ))
          .reverse()}
      </div>
    </div>
  );
};
